import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'document-icon',
    imports:[
        MatIconModule, CommonModule
    ],
    template: `
        <div class="flex h-full">
            <div class="relative">
                <mat-icon
                    class="text-hint opacity-50 icon-size-8"
                    [svgIcon]="
                        'heroicons_solid:document'
                    "
                ></mat-icon>
                <div
                    class="absolute bottom-0 left-0 rounded px-1 text-xs font-semibold leading-5 text-white"
                    [ngClass]="background"
                    >
                    {{tipoDocumento}}
                </div>
            </div>
        </div>        
    `
})

export class DocumentIconComponent implements OnInit {
    @Input() tipoDocumento:string
    @Input() background:string

    constructor() { }

    ngOnInit() { }
}